module.exports = __webpack_public_path__ + "static/img/innorecycling.f5121ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/innorecycling.png
// module id = 490
// module chunks = 1